import { mapGetters } from 'vuex';
import { ModuleContext, ModuleBudgetSource, ModuleBudgetKindItem } from '@/stores/moduleConst';
import { showError } from '@/commons/globalMessage';
import SysUserAPI from '@/apis/di/sysUserAPI.js';
import SysRoleAPI from '@/apis/di/sysRoleAPI.js';
export const permission = {
  data() {
    return {
      /**
       * mã phân hệ để kiểm tra phân quyền
       */
      subSystemCode: null,
    };
  },
  computed: {
    ...mapGetters({
      _permissionData: ModuleContext + '/Permission',
      context: ModuleContext + '/Context',
    }),
  },
  methods: {
    /**
     * Kiểm tra action command có quyền thực hiện không
     * Dùng để kiểm tra khi click vào các nút trên form
     * @param {string/array<string>} permission : quyền gì, nếu array thì 1 item pass là ok
     * @param {string} subSystemCode : trường hợp gọi validate custom, chỉ định đích danh chức năng nào, không dùng cấu hình subSystemCode trong data
     * @returns : true có quyền
     */
    checkActionPermission(permission, subSystemCode) {
      const me = this;
      //Nếu không có vai trò hoặc là lãnh đạo thì chỉ cho quyền xem
      if (me.context.IsLeader) {
        if (permission === me.$ms.constant.Permission.View || permission === me.$ms.constant.Permission.Print) {
          return true;
        }
        return false;
      }
      //Không có hoặc khi là admin thì đều null
      if (!me._permissionData) {
        return true;
      }

      //Không có thông tin Chức năng thì bỏ qua
      let subCode = subSystemCode || me.getSubSystemCode();
      if (!subCode) {
        return true;
      }

      //permission có trong danh sách quyền hay không - tvhien - 07.12.2022
      let allowPermissions = me._permissionData[subCode];
      if (allowPermissions && allowPermissions.some(x => (x & permission) != 0)) {
        return false;
      }
      return true;
    },

    /**
     * Kiểm tra quyền có cảnh báo
     * dqvinh edit 26.4.2023: Thêm title và msg để custom câu thông báo nếu muốn
     */
    checkActionPermissionAlert(permission, subSystemCode, custom_title = null, custom_msg = null) {
      const res = this.checkActionPermission(permission, subSystemCode);

      if (!res) {
        let msg = custom_msg ?? this.$t('i18nBaseForm.Validate.NotPermission');
        let title = custom_title ?? this.$t('i18nBaseForm.Validate.TitleNotPermission');
        showError(msg, title);
        throw msg;
      }
    },

    /**
     * Lấy mã phân quyền SubSystemCode của form
     * @param {*} reportItem: trường hợp phân quyền báo cáo thì lấy theo config báo cáo
     * @returns
     * nxhoa 9.12.2022
     */
    getSubSystemCode(reportItem) {
      const me = this;
      let subSystemCode = me.subSystemCode;

      if (reportItem && reportItem.reportId) {
        subSystemCode = `Rp_${reportItem.reportId}`;
        switch (reportItem.reportId) {
          default:
            break;
        }
      }

      return subSystemCode;
    },

    /**
     * Thực hiện check phân quyền chức năng Sao chép dữ liệu
     * Người dùng được quyền sử dụng : không check chọn phân quyền theo Mục lục ngân sách | Có check chọn phân quyền theo Mục lục ngân nhưng được phân quyền sử dụng tất cả Nguồn; Khoản
     * @param {*} permision
     * dtnga3 (01.06.2023)
     */
    async checkCopyDataPermissionAlert1(permision) {
      var me = this;
      let userData = await SysUserAPI.getList({
        take: 100,
        columns: 'full_name,user_id,role_id',
        type: 0,
      });
      let sysRoleData = await SysRoleAPI.getList({
        take: 100,
        columns: 'role_code,role_id,is_budget_permission',
      });

      let budgetSourceData = await me.$store.dispatch(`${ModuleBudgetSource}/getFullList`, { columns: '*' });
      let budgetKindItemData = await me.$store.dispatch(`${ModuleBudgetKindItem}/getFullList`, { columns: '*' });
      let budgetKindData = budgetKindItemData?.filter(x => x.is_parent);

      let user = userData?.PageData?.find(x => x.user_id == me.context.UserID);
      let userRoleData = sysRoleData?.PageData?.find(x => x.role_id == user?.role_id);
      if (userRoleData) {
        let isBudgetPermissions = userRoleData.is_budget_permission; // Có tích chọn phân quyền theo MLNS không
        if (isBudgetPermissions && me._permissionData) {
          // _permissionData đang lưu các mục không được phân quyền nên nếu không có nguồn/khoản nào có trong đây thì là được full quyền đối với danh mục nguồn /khoản
          let isFullPermissionBudgetSource = !budgetSourceData.some(
            x => me._permissionData['NGUON_' + x.budget_source_id]
          ); // Có tích chọn Sử dụng tất cả Nguồn không
          let isFullPermissionBudgetKindItem = !budgetKindData.some(
            x => me._permissionData['KHOAN_' + x.budget_kind_item_id]
          ); // Có tích chọn Sử dụng tất cả Khoản không
          if (
            (isFullPermissionBudgetSource && !isFullPermissionBudgetKindItem) ||
            (!isFullPermissionBudgetSource && isFullPermissionBudgetKindItem) ||
            (!isFullPermissionBudgetSource && !isFullPermissionBudgetKindItem)
          ) {
            let msg = custom_msg ?? this.$t('i18nBaseForm.Validate.NotPermission');
            let title = custom_title ?? this.$t('i18nBaseForm.Validate.TitleNotPermission');
            showError(msg, title);
            throw msg;
          }
        }
      } else {
        return;
      }
    },

    /**
     * Thực hiện check phân quyền chức năng Sao chép dữ liệu
     * Người dùng được quyền sử dụng : Người dùng không phải là lãnh đạo
     * @param {*} permision
     * dtnga3 (14.06.2023) sửa theo tài liệu sau CCB
     */
    async checkCopyDataPermissionAlert(permision) {
      if (this.context.IsLeader) {
        let msg = this.$t('i18nBaseForm.Validate.NotPermission');
        let title = this.$t('i18nBaseForm.Validate.TitleNotPermission');
        showError(msg, title);
        throw msg;
      } else {
        return;
      }
    },
  },
};
